/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { CheckAndSignReq } from '../models/check-and-sign-req';
import { CheckAndSignResp } from '../models/check-and-sign-resp';
import { CmsScopeResp } from '../models/cms-scope-resp';
import { ContactFormReq } from '../models/contact-form-req';
import { ContactFormResp } from '../models/contact-form-resp';
import { FindProductsReq } from '../models/find-products-req';
import { FindProductsResp } from '../models/find-products-resp';
import { GetAOrderReq } from '../models/get-a-order-req';
import { GetAOrderResp } from '../models/get-a-order-resp';
import { GetAllInvoicesResp } from '../models/get-all-invoices-resp';
import { GetAllOrdersReq } from '../models/get-all-orders-req';
import { GetAllOrdersResp } from '../models/get-all-orders-resp';
import { GetItemResp } from '../models/get-item-resp';
import { GetItemsReq } from '../models/get-items-req';
import { OrderPutReq } from '../models/order-put-req';
import { OrderPutResp } from '../models/order-put-resp';
import { ProductsInACategoryReq } from '../models/products-in-a-category-req';
import { ProductsInACategoryResp } from '../models/products-in-a-category-resp';
import { RandomSoldItemResp } from '../models/random-sold-item-resp';
import { ReservateProductReq } from '../models/reservate-product-req';
import { ReservateProductResp } from '../models/reservate-product-resp';
import { SoldProductsReq } from '../models/sold-products-req';
import { SoldProductsResp } from '../models/sold-products-resp';

@Injectable({
  providedIn: 'root',
})
export class PublicShopService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation findProducts
   */
  static readonly FindProductsPath = '/public-shop/find';

  /**
   * Find Products
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findProducts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findProducts$Response(params: {
    body: FindProductsReq
  }): Observable<StrictHttpResponse<FindProductsResp>> {

    const rb = new RequestBuilder(this.rootUrl, PublicShopService.FindProductsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<FindProductsResp>;
      })
    );
  }

  /**
   * Find Products
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findProducts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  findProducts(params: {
    body: FindProductsReq
  }): Observable<FindProductsResp> {

    return this.findProducts$Response(params).pipe(
      map((r: StrictHttpResponse<FindProductsResp>) => r.body as FindProductsResp)
    );
  }

  /**
   * Path part for operation soldProducts
   */
  static readonly SoldProductsPath = '/public-shop/sold-products';

  /**
   * Import order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `soldProducts()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  soldProducts$Response(params: {
    body: SoldProductsReq
  }): Observable<StrictHttpResponse<SoldProductsResp>> {

    const rb = new RequestBuilder(this.rootUrl, PublicShopService.SoldProductsPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<SoldProductsResp>;
      })
    );
  }

  /**
   * Import order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `soldProducts$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  soldProducts(params: {
    body: SoldProductsReq
  }): Observable<SoldProductsResp> {

    return this.soldProducts$Response(params).pipe(
      map((r: StrictHttpResponse<SoldProductsResp>) => r.body as SoldProductsResp)
    );
  }

  /**
   * Path part for operation productsInACategory
   */
  static readonly ProductsInACategoryPath = '/public-shop/products-category';

  /**
   * All products in a category.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `productsInACategory()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productsInACategory$Response(params: {

    /**
     * Paginator page
     */
    page?: number;
    body: ProductsInACategoryReq
  }): Observable<StrictHttpResponse<ProductsInACategoryResp>> {

    const rb = new RequestBuilder(this.rootUrl, PublicShopService.ProductsInACategoryPath, 'post');
    if (params) {
      rb.query('page', params.page, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ProductsInACategoryResp>;
      })
    );
  }

  /**
   * All products in a category.
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `productsInACategory$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  productsInACategory(params: {

    /**
     * Paginator page
     */
    page?: number;
    body: ProductsInACategoryReq
  }): Observable<ProductsInACategoryResp> {

    return this.productsInACategory$Response(params).pipe(
      map((r: StrictHttpResponse<ProductsInACategoryResp>) => r.body as ProductsInACategoryResp)
    );
  }

  /**
   * Path part for operation getItem
   */
  static readonly GetItemPath = '/public-shop/item';

  /**
   * Get item
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getItem()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getItem$Response(params: {
    body: GetItemsReq
  }): Observable<StrictHttpResponse<GetItemResp>> {

    const rb = new RequestBuilder(this.rootUrl, PublicShopService.GetItemPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetItemResp>;
      })
    );
  }

  /**
   * Get item
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getItem$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getItem(params: {
    body: GetItemsReq
  }): Observable<GetItemResp> {

    return this.getItem$Response(params).pipe(
      map((r: StrictHttpResponse<GetItemResp>) => r.body as GetItemResp)
    );
  }

  /**
   * Path part for operation checkAndSign
   */
  static readonly CheckAndSignPath = '/public-shop/check-and-sign-order';

  /**
   * check And Sign Order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `checkAndSign()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  checkAndSign$Response(params: {
    body: CheckAndSignReq
  }): Observable<StrictHttpResponse<CheckAndSignResp>> {

    const rb = new RequestBuilder(this.rootUrl, PublicShopService.CheckAndSignPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CheckAndSignResp>;
      })
    );
  }

  /**
   * check And Sign Order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `checkAndSign$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  checkAndSign(params: {
    body: CheckAndSignReq
  }): Observable<CheckAndSignResp> {

    return this.checkAndSign$Response(params).pipe(
      map((r: StrictHttpResponse<CheckAndSignResp>) => r.body as CheckAndSignResp)
    );
  }

  /**
   * Path part for operation getMyInvoices
   */
  static readonly GetMyInvoicesPath = '/public-shop/get-all-invoices';

  /**
   * Get all invoices from a user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMyInvoices()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyInvoices$Response(params?: {
  }): Observable<StrictHttpResponse<GetAllInvoicesResp>> {

    const rb = new RequestBuilder(this.rootUrl, PublicShopService.GetMyInvoicesPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetAllInvoicesResp>;
      })
    );
  }

  /**
   * Get all invoices from a user
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getMyInvoices$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMyInvoices(params?: {
  }): Observable<GetAllInvoicesResp> {

    return this.getMyInvoices$Response(params).pipe(
      map((r: StrictHttpResponse<GetAllInvoicesResp>) => r.body as GetAllInvoicesResp)
    );
  }

  /**
   * Path part for operation getAllOrders
   */
  static readonly GetAllOrdersPath = '/public-shop/get-all-orders';

  /**
   * Get all orders from a user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAllOrders()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAllOrders$Response(params: {
    body: GetAllOrdersReq
  }): Observable<StrictHttpResponse<GetAllOrdersResp>> {

    const rb = new RequestBuilder(this.rootUrl, PublicShopService.GetAllOrdersPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetAllOrdersResp>;
      })
    );
  }

  /**
   * Get all orders from a user
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAllOrders$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAllOrders(params: {
    body: GetAllOrdersReq
  }): Observable<GetAllOrdersResp> {

    return this.getAllOrders$Response(params).pipe(
      map((r: StrictHttpResponse<GetAllOrdersResp>) => r.body as GetAllOrdersResp)
    );
  }

  /**
   * Path part for operation getAOrder
   */
  static readonly GetAOrderPath = '/public-shop/get-order';

  /**
   * Get a order from user
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getAOrder()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAOrder$Response(params: {
    body: GetAOrderReq
  }): Observable<StrictHttpResponse<GetAOrderResp>> {

    const rb = new RequestBuilder(this.rootUrl, PublicShopService.GetAOrderPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<GetAOrderResp>;
      })
    );
  }

  /**
   * Get a order from user
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getAOrder$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  getAOrder(params: {
    body: GetAOrderReq
  }): Observable<GetAOrderResp> {

    return this.getAOrder$Response(params).pipe(
      map((r: StrictHttpResponse<GetAOrderResp>) => r.body as GetAOrderResp)
    );
  }

  /**
   * Path part for operation orderPut
   */
  static readonly OrderPutPath = '/public-shop/put-order';

  /**
   * Put order
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `orderPut()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderPut$Response(params: {
    body: OrderPutReq
  }): Observable<StrictHttpResponse<OrderPutResp>> {

    const rb = new RequestBuilder(this.rootUrl, PublicShopService.OrderPutPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<OrderPutResp>;
      })
    );
  }

  /**
   * Put order
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `orderPut$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  orderPut(params: {
    body: OrderPutReq
  }): Observable<OrderPutResp> {

    return this.orderPut$Response(params).pipe(
      map((r: StrictHttpResponse<OrderPutResp>) => r.body as OrderPutResp)
    );
  }

  /**
   * Path part for operation reservateProduct
   */
  static readonly ReservateProductPath = '/public-shop/reservate-product';

  /**
   * Contact
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `reservateProduct()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservateProduct$Response(params: {
    body: ReservateProductReq
  }): Observable<StrictHttpResponse<ReservateProductResp>> {

    const rb = new RequestBuilder(this.rootUrl, PublicShopService.ReservateProductPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ReservateProductResp>;
      })
    );
  }

  /**
   * Contact
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `reservateProduct$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  reservateProduct(params: {
    body: ReservateProductReq
  }): Observable<ReservateProductResp> {

    return this.reservateProduct$Response(params).pipe(
      map((r: StrictHttpResponse<ReservateProductResp>) => r.body as ReservateProductResp)
    );
  }

  /**
   * Path part for operation contactForm
   */
  static readonly ContactFormPath = '/public-shop/contact';

  /**
   * Contact
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `contactForm()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactForm$Response(params: {
    body: ContactFormReq
  }): Observable<StrictHttpResponse<ContactFormResp>> {

    const rb = new RequestBuilder(this.rootUrl, PublicShopService.ContactFormPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<ContactFormResp>;
      })
    );
  }

  /**
   * Contact
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `contactForm$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  contactForm(params: {
    body: ContactFormReq
  }): Observable<ContactFormResp> {

    return this.contactForm$Response(params).pipe(
      map((r: StrictHttpResponse<ContactFormResp>) => r.body as ContactFormResp)
    );
  }

  /**
   * Path part for operation getSoldItem
   */
  static readonly GetSoldItemPath = '/public-shop/random-sold-item';

  /**
   * Random Sold Item
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSoldItem()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSoldItem$Response(params?: {
  }): Observable<StrictHttpResponse<RandomSoldItemResp>> {

    const rb = new RequestBuilder(this.rootUrl, PublicShopService.GetSoldItemPath, 'get');
    if (params) {
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<RandomSoldItemResp>;
      })
    );
  }

  /**
   * Random Sold Item
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getSoldItem$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSoldItem(params?: {
  }): Observable<RandomSoldItemResp> {

    return this.getSoldItem$Response(params).pipe(
      map((r: StrictHttpResponse<RandomSoldItemResp>) => r.body as RandomSoldItemResp)
    );
  }

  /**
   * Path part for operation getShopCms
   */
  static readonly GetShopCmsPath = '/public-shop/cms/{scope}';

  /**
   * Get information about a CMS
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getShopCms()` instead.
   *
   * This method doesn't expect any request body.
   */
  getShopCms$Response(params: {

    /**
     * cms scope
     */
    scope: string;
  }): Observable<StrictHttpResponse<CmsScopeResp>> {

    const rb = new RequestBuilder(this.rootUrl, PublicShopService.GetShopCmsPath, 'get');
    if (params) {
      rb.path('scope', params.scope, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<CmsScopeResp>;
      })
    );
  }

  /**
   * Get information about a CMS
   *
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `getShopCms$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getShopCms(params: {

    /**
     * cms scope
     */
    scope: string;
  }): Observable<CmsScopeResp> {

    return this.getShopCms$Response(params).pipe(
      map((r: StrictHttpResponse<CmsScopeResp>) => r.body as CmsScopeResp)
    );
  }

}
